/**
 * 24-hour raincheck policy copy (CWS-1523).
 *
 * The customer-facing promise is printed on the receipt/invoice by the Angular app and
 * sent in the purchase SMS by svc-order. Both read this module so the two can never
 * drift apart — the acceptance criteria require the copy to be identical on both.
 *
 * Angular imports it through the `@car-wash/raincheck-policy` path alias (the package
 * index pulls in winston/joi, which do not belong in a browser bundle).
 * @module raincheckPolicy
 */

/** Hours a customer has to return for a free rewash, counted from the purchase. */
const RAINCHECK_WINDOW_HOURS = 24;

/** Verbatim customer-facing copy. Shown on the invoice/receipt and in the purchase SMS. */
const RAINCHECK_MESSAGE = 'Return within 24 hours for a free raincheck.';

/**
 * Wash types the raincheck is advertised on. Only a single wash purchase carries the
 * promise today; membership and prepaid book purchases are not a wash on their own.
 */
const RAINCHECK_WASH_TYPES = Object.freeze(['single_wash']);

/**
 * @param {string | null | undefined} washType `orders.wash_type`
 * @returns {boolean} True when the raincheck message belongs on this order's receipt/SMS.
 */
function isRaincheckWashType(washType) {
  if (washType === null || washType === undefined) {
    return false;
  }
  return RAINCHECK_WASH_TYPES.includes(String(washType).trim().toLowerCase());
}

module.exports = {
  RAINCHECK_WINDOW_HOURS,
  RAINCHECK_MESSAGE,
  RAINCHECK_WASH_TYPES,
  isRaincheckWashType,
};
